module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', {
    attrs: {
      "columns": "40/60"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "slot": "header",
      "dark": ""
    },
    slot: "header"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Templates for " + _vm._s(_vm.officeName))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', [_c('v-list-item-title', [_vm._v("Office " + _vm._s(_vm.tenantKey))])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.goToTemplateMaintenance
    }
  }, [_c('v-list-item-title', [_vm._v("Template Maintenance")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "col1",
      "pa-3": ""
    },
    slot: "col1"
  }, [_c('div', {
    staticClass: "pa-3",
    staticStyle: {
      "flex-basis": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "no-border full-width",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, _vm._l((_vm.visibleTemplates), function(tmpl) {
    return _c('v-list-item', {
      key: tmpl.key,
      class: {
        'border-transparent': true, 'blue-hilight': (_vm.template.key == tmpl.key)
      },
      attrs: {
        "disabled": _vm.editing
      },
      on: {
        "click": function($event) {
          return _vm.selectTemplate(tmpl)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(tmpl.group) + " - " + _vm._s(tmpl.name))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(tmpl.subject))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("info")])], 1)], 1)], 1)
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "col2"
    },
    slot: "col2"
  }, [_c('div', {
    staticClass: "ml-4 mr-2"
  }, [_c('div', [_c('div', [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Group",
      "prepend-icon": "note"
    },
    model: {
      value: (_vm.template.group),
      callback: function($$v) {
        _vm.$set(_vm.template, "group", $$v)
      },
      expression: "template.group"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Name",
      "prepend-icon": "widgets"
    },
    model: {
      value: (_vm.template.name),
      callback: function($$v) {
        _vm.$set(_vm.template, "name", $$v)
      },
      expression: "template.name"
    }
  })], 1)]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Subject"
    },
    model: {
      value: (_vm.template.subject),
      callback: function($$v) {
        _vm.$set(_vm.template, "subject", $$v)
      },
      expression: "template.subject"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('HtmlEditor', {
    model: {
      value: (_vm.template.body),
      callback: function($$v) {
        _vm.$set(_vm.template, "body", $$v)
      },
      expression: "template.body"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "color": "primary",
      "hide-details": "",
      "label": "Personal Template",
      "light": ""
    },
    model: {
      value: (_vm.template.personal),
      callback: function($$v) {
        _vm.$set(_vm.template, "personal", $$v)
      },
      expression: "template.personal"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('DeleteButton', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.template.key
    },
    on: {
      "delete": _vm.deleteTemplate
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "",
      "text": "",
      "color": "grey"
    },
    on: {
      "click": _vm.viewHtml
    }
  }, [_c('v-icon', [_vm._v("text_fields")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.editing,
      "color": "primary"
    },
    on: {
      "click": _vm.saveTemplate
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.editing
    },
    on: {
      "click": _vm.cancelEditing
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": !_vm.template.key || _vm.editing
    },
    on: {
      "click": _vm.copyTemplate
    }
  }, [_vm._v("Make a Copy")]), _vm._v(" "), (_vm.viewHtmlBox) ? _c('v-textarea', {
    attrs: {
      "label": "HTML View",
      "rows": 10
    },
    model: {
      value: (_vm.template.body),
      callback: function($$v) {
        _vm.$set(_vm.template, "body", $$v)
      },
      expression: "template.body"
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b6413c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Templates.vue
// module id = 2444
// module chunks = 1